import React from 'react';
import { XIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { painPoints } from '../../data/landing';
export function Problem() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-225" data-mp="2whhj7h5w97ue">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-226" data-mp="2rn3vm0xh450a">
        <div data-id="element-227" data-mp="2mo95edx6fe65">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-brand md:text-6xl" data-id="element-228" data-mp="2mosldp39nshj">
            ¿Cuántos domingos más vas a vivir <span className="text-danger" data-id="element-229" data-mp="2cr4ek0sdyuj0">con esto?</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-charcoal" data-id="element-230" data-mp="2cptd47mexyv2">
            Tienes colon irritable. Amas comer. Pero nadie te dijo que ibas a pasar los fines de semana con miedo a salir a comer , en los almuerzos evitando ciertos alimentos y llegando a la noche inflamado sin entender por qué.
          </p>
          <p className="mt-6 text-2xl font-extrabold leading-snug text-charcoal" data-id="element-231" data-mp="6vto63u0nacd">
            No es tu culpa. <Highlight data-id="element-232" data-mp="1x8lzyv7egla">Nadie te dio un plan claro… hasta hoy.</Highlight>
          </p>
        </div>

        <div data-id="element-233" data-mp="14deq9cvt1ua3">
          <ul className="divide-y divide-danger/15 overflow-hidden rounded-3xl border border-danger/20 bg-danger-soft" data-id="element-234" data-mp="199wt277krijs">
            {painPoints.map(p => <li key={p} className="flex items-start gap-4 px-6 py-5" data-id="element-235" data-mp="vbp00adnt1dw">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-236" data-mp="108yn3jdkt0yk">
                  <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-237" data-mp="1o043bznfhv9e" />
                </span>
                <span className="text-base font-medium text-charcoal md:text-lg" data-id="element-238" data-mp="1s04ric0bxktn">{p}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xl font-bold italic text-brand md:text-left" data-id="element-239" data-mp="1e75bm8wmxolk">
            ¿Y si este fuera el último fin de semana que vives así?
          </p>
        </div>
      </div>
    </section>;
}